import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { useSnackbar } from "notistack";

import InviteDialog from "../../components/dialogs/inviteDialog";

import constants from "../../assets/constants";
import * as OmniDataAPI from "../../data/omniDataAPI";
import * as AdminSessionActions from "../../state/redux/adminSession";
import AlertDialog from "../dialogs/alertDialog";
import SurveyInvites from "../ui/surveyInvites";
import Widget from "../ui/widget";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetSurveyContent from "../ui/widgetSurveyContent";
import WidgetTitle from "../ui/widgetTitle";

const AdminPartnerInvites = props => {
  const {
    autoInviteODMs,
    reflectUpdatedInviteODMRequest,
    autoInvitePageLoading,
    loadAutoInvitesRequest,
    autoInvitePagination,
  } = props;

  useEffect(() => {
    if (autoInviteODMs != null) {
      setRows(autoInviteODMs);
    }
  }, [autoInviteODMs]);

  const { enqueueSnackbar } = useSnackbar();

  const [titleText, setTitleText] = useState(null);
  const [rows, setRows] = useState([]);
  const [deleteInvite, setDeleteInvite] = useState(null);

  const [newInvite, setNewInvite] = useState(null);
  const [selectedInvite, setSelectedInvite] = useState(null);

  useEffect(() => {
    if (autoInvitePagination != null) {
      setTitleText(
        `${autoInvitePagination.totalItems} Partner Shared Invitation${
          autoInvitePagination.totalItems === 1 ? "" : "s"
        }`,
      );
    } else {
      setTitleText("Loading...");
    }

    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoInvitePagination]);

  return (
    <Widget>
      <WidgetTitle title={"Auto Invites"} text={titleText}></WidgetTitle>

      {rows == null && <WidgetSkeleton />}
      {rows != null && (
        <WidgetSurveyContent>
          <SurveyInvites
            inviteODMs={rows}
            onEditInvite={setSelectedInvite}
            onDeleteInvite={setDeleteInvite}
            inviteSurveyType={constants.inviteSurveyType.auto}
            onRequestNewPage={loadAutoInvitesRequest}
            isLoading={autoInvitePageLoading}
            invitePagination={autoInvitePagination}
          />
        </WidgetSurveyContent>
      )}
      {deleteInvite && (
        <AlertDialog
          open={deleteInvite != null}
          dialogTitle={"Delete Invite Confirmation"}
          dialogMessage={`Are you sure that you want to delete ${deleteInvite.omniData.userData.v} ${deleteInvite.omniData.userData.familyName}'s invite?`}
          onAccept={() => {
            const id = deleteInvite._id;
            setDeleteInvite(null);
            OmniDataAPI.deleteInvite(id).then(response => {
              if (response != null) {
                enqueueSnackbar("Invite Deleted Successfully.", {
                  variant: "success",
                });

                reflectUpdatedInviteODMRequest(deleteInvite);
              } else {
                enqueueSnackbar("Invite Delete Failed!", {
                  variant: "error",
                });
              }
            });
          }}
          onClose={() => {
            setDeleteInvite(null);
          }}
        />
      )}

      {newInvite && (
        <InviteDialog
          open={newInvite != null}
          omniODM={newInvite}
          onAccept={modifiedInvite => {
            OmniDataAPI.createInvite(modifiedInvite).then(response => {
              if (response != null) {
                enqueueSnackbar("Invite Created Successfully.", {
                  variant: "success",
                });
                props.reflectUpdatedInviteODMRequest(response);
              } else {
                enqueueSnackbar("Invite Creation Failed!", {
                  variant: "error",
                });
              }
            });

            setNewInvite(null);
          }}
          onClose={() => {
            setNewInvite(null);
          }}
        />
      )}

      {selectedInvite && (
        <InviteDialog
          tabId={1}
          open={selectedInvite != null}
          omniODM={selectedInvite}
          onAccept={modifiedInvite => {
            //TODO fix this
            setSelectedInvite(null);
          }}
          onClose={() => {
            setSelectedInvite(null);
          }}
        />
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  autoInviteODMs: state.adminSession.autoInviteODMs,
  autoInvitePageLoading: state.adminSession.autoInvitePageLoading,
  autoInvitePagination: state.adminSession.autoInvitePagination,
});

const mapDispatchToProps = {
  reflectUpdatedInviteODMRequest: AdminSessionActions.reflectUpdatedInviteODMRequest,
  loadAutoInvitesRequest: AdminSessionActions.loadAutoInvitesRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminPartnerInvites));
